import { createPortal } from "react-dom";
import { NavLink } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { X, Phone } from "lucide-react";
import { NAV, CONTACT, EASE, slug } from "@/lib/site";
import QuoteButton from "@/components/ui-kit/QuoteButton";

export default function MobileNav({ open, onClose }) {
  return createPortal(
    <AnimatePresence>
      {open && (
        <motion.div data-testid="mobile-navigation-drawer" data-lenis-prevent
          initial={{ clipPath: "inset(0 0 100% 0)" }} animate={{ clipPath: "inset(0 0 0% 0)" }} exit={{ clipPath: "inset(0 0 100% 0)" }}
          transition={{ duration: 0.6, ease: EASE }}
          className="fixed inset-0 z-[60] bg-[var(--ink)] text-white flex flex-col lg:hidden">
          <div className="flex items-center justify-between px-4 sm:px-8 h-20 border-b border-white/10">
            <span className="font-display italic font-extrabold text-2xl tracking-wide">MENU</span>
            <button data-testid="mobile-menu-close" onClick={onClose} aria-label="Close menu" className="w-11 h-11 grid place-items-center bg-[var(--red)] chamfer-sm">
              <X className="w-5 h-5" />
            </button>
          </div>
          <nav className="flex-1 px-4 sm:px-8 py-8 flex flex-col gap-2 overflow-y-auto">
            {NAV.map((n, i) => (
              <motion.div key={n.to} initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.2 + i * 0.06, duration: 0.5, ease: EASE }}>
                <NavLink to={n.to} end={!n.children} onClick={onClose} data-testid={`mobile-nav-link-${slug(n.to)}`}
                  className={({ isActive }) => `flex items-baseline gap-4 py-3 ${n.children ? "" : "border-b border-white/10"} font-display italic font-extrabold uppercase text-3xl sm:text-4xl ${isActive ? "text-[#ff4d53]" : "text-white"}`}>
                  <span className="text-xs not-italic font-sans font-semibold text-white/50">0{i + 1}</span>{n.label}
                </NavLink>
                {n.children && (
                  <div className="pl-9 pb-3 border-b border-white/10 flex flex-col">
                    {n.children.map((c) => (
                      <NavLink key={c.to} to={c.to} onClick={onClose} data-testid={`mobile-nav-sublink-${slug(c.to)}`}
                        className={({ isActive }) => `py-2 text-base font-semibold flex items-center gap-3 ${isActive ? "text-[#ff4d53]" : "text-white/85"}`}>
                        <span className="w-4 h-[2px] bg-[var(--red)] -skew-x-[30deg]" />{c.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </motion.div>
            ))}
          </nav>
          <div className="px-4 sm:px-8 pb-10 flex flex-col gap-4">
            <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 text-white/80"><Phone className="w-4 h-4 text-[#ff6b70]" />{CONTACT.phone}</a>
            <div onClick={onClose}><QuoteButton testId="mobile-get-quote-button" className="w-full justify-center" /></div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
}
